import React from 'react';
import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { PrincipleList } from '../components/PrincipleList';
import { MethodSteps } from '../components/MethodSteps';
import { CtaBand } from '../components/CtaBand';
import { candidatePrinciples, clientPartnership, mission, searchPhilosophy, values, vision } from '../data/about';
export function About() {
  return <>
      <PageHero breadcrumb="About Us" title="A partner for the decisions that shape organizations." lead="Qorvessa Executive Partners advises boards, chief executives, and investors on the appointments that matter most — with discretion, rigor, and a long-term view." data-id="element-324" data-mp="329lzngfn3bkv" />

      <section className="bg-ivory" data-id="element-325" data-mp="2x7mxuazjsmq1">
        <div className="mx-auto grid max-w-site gap-10 px-6 py-24 lg:grid-cols-12 lg:px-10 lg:py-32" data-id="element-326" data-mp="2xb0yneskcnvd">
          <Reveal className="lg:col-span-5" data-id="element-327" data-mp="1lu19gs1iip5k">
            <h2 className="font-serif text-4xl leading-tight text-midnight-900 md:text-5xl" data-id="element-328" data-mp="1luu8t7y56cdo">Who we are</h2>
          </Reveal>
          <Reveal delay={0.06} className="space-y-5 text-[17px] leading-relaxed text-midnight-900/75 lg:col-span-6 lg:col-start-7" data-id="element-329" data-mp="1ui1vqt1u94im">
            <p data-id="element-330" data-mp="23i864628podk">
              We are a retained executive search and leadership advisory firm. Our work spans board and CEO appointments, C-suite
              and functional leadership, interim executives, and succession planning across a range of industries.
            </p>
            <p data-id="element-331" data-mp="2dejnhagot4ev">
              We deliberately limit the number of mandates we take on, so every client works directly with senior partners and
              every candidate receives the time and candor they deserve.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-midnight-950 text-champagne-50" data-id="element-332" data-mp="2i7w530my8ay4">
        <div className="mx-auto grid max-w-site gap-14 px-6 py-24 lg:grid-cols-2 lg:gap-0 lg:px-10 lg:py-32" data-id="element-333" data-mp="2w6ceizc74fjy">
          <Reveal className="lg:pr-14" data-id="element-334" data-mp="2r93s2mk0lpcw">
            <h2 className="text-sm font-medium text-champagne-300" data-id="element-335" data-mp="2r5y63g6on3le">Our mission</h2>
            <p className="mt-5 font-serif text-3xl leading-snug md:text-4xl" data-id="element-336" data-mp="1owhdrhx1puuf">{mission}</p>
          </Reveal>
          <Reveal delay={0.06} className="border-t border-champagne-100/15 pt-14 lg:border-l lg:border-t-0 lg:pl-14 lg:pt-0" data-id="element-337" data-mp="1swhuj97mai4n">
            <h2 className="text-sm font-medium text-champagne-300" data-id="element-338" data-mp="22m1b287uxzwc">Our vision</h2>
            <p className="mt-5 font-serif text-3xl leading-snug md:text-4xl" data-id="element-339" data-mp="22nvx5puv7y20">{vision}</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ivory" data-id="element-340" data-mp="2cjpfxqz6gns8">
        <div className="mx-auto max-w-site px-6 py-24 lg:px-10 lg:py-32" data-id="element-341" data-mp="2cinv4usd0mxb">
          <h2 className="font-serif text-4xl text-midnight-900 md:text-5xl" data-id="element-342" data-mp="2gmvl0vak08x4">Our values</h2>
          <div className="mt-12" data-id="element-343" data-mp="2ll5jberkrpmy">
            <PrincipleList items={values} columns={4} data-id="element-344" data-mp="2lk45x3n36r22" />
          </div>
        </div>
      </section>

      <section className="bg-champagne-50" data-id="element-345" data-mp="m9m80tisu5a4">
        <div className="mx-auto grid max-w-site gap-10 px-6 py-24 lg:grid-cols-12 lg:px-10 lg:py-32" data-id="element-346" data-mp="r6mcx13wx1zn">
          <Reveal className="lg:col-span-5" data-id="element-347" data-mp="jnv9wxbs8xw8">
            <h2 className="font-serif text-4xl leading-tight text-midnight-900 md:text-5xl" data-id="element-348" data-mp="joy35bwkvcfb">Our search philosophy</h2>
          </Reveal>
          <Reveal delay={0.06} className="space-y-5 text-[17px] leading-relaxed text-midnight-900/75 lg:col-span-6 lg:col-start-7" data-id="element-349" data-mp="9xjv2fqk94ak">
            {searchPhilosophy.map(paragraph => <p key={paragraph.slice(0, 24)} data-id="element-350" data-mp="4wmci21n288j">{paragraph}</p>)}
          </Reveal>
        </div>
      </section>

      <section className="bg-ivory" data-id="element-351" data-mp="xne6qtz58mt8">
        <div className="mx-auto grid max-w-site gap-20 px-6 py-24 lg:grid-cols-2 lg:gap-16 lg:px-10 lg:py-32" data-id="element-352" data-mp="xofsbsdscrp7">
          <div data-id="element-353" data-mp="smgpcjlyjwss">
            <h2 className="font-serif text-4xl text-midnight-900" data-id="element-354" data-mp="sq4i3gjkwf6g">How we partner with clients</h2>
            <div className="mt-10" data-id="element-355" data-mp="ooixta4psym8">
              <PrincipleList items={clientPartnership} data-id="element-356" data-mp="3desa6rtwlq1l" />
            </div>
          </div>
          <div data-id="element-357" data-mp="39cxafrrmfkpx">
            <h2 className="font-serif text-4xl text-midnight-900" data-id="element-358" data-mp="39cfgx2wcfklp">How we engage candidates</h2>
            <div className="mt-10" data-id="element-359" data-mp="113h1rkdo67ue">
              <PrincipleList items={candidatePrinciples} data-id="element-360" data-mp="112eedmfk2nj8" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-midnight-950 text-champagne-50" data-id="element-361" data-mp="15wsdnzxc9et6">
        <div className="mx-auto max-w-site px-6 py-24 lg:px-10 lg:py-32" data-id="element-362" data-mp="r6umdb4448zr">
          <div className="max-w-2xl" data-id="element-363" data-mp="w4cvp2m1kq8a">
            <h2 className="font-serif text-4xl md:text-5xl" data-id="element-364" data-mp="w5fiaycc06ie">Our search methodology</h2>
            <p className="mt-5 text-[17px] leading-relaxed text-champagne-100/70" data-id="element-365" data-mp="1jvs1j5d11poa">
              A consistent, transparent process — tailored to each mandate, but never improvised.
            </p>
          </div>
          <div className="mt-14" data-id="element-366" data-mp="1at8xihxi970g">
            <MethodSteps tone="dark" data-id="element-367" data-mp="1evdrxivs27o5" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-368" data-mp="1exgqirazx94h" />
    </>;
}